<template>
  <div id="commodityMgmt">
    <div ref="header" class="header-box">
      <div class="header-line">
        <span class="header-label">asin</span>
        <el-input placeholder="请输入asin" size="small" clearable v-model="params.asin"> </el-input>
        <span class="header-label">卖家名称</span>
        <el-input placeholder="请输入卖家名称" size="small" clearable v-model="params.shopName"> </el-input>
        <span class="header-label">品牌名称</span>
        <el-input placeholder="请输入品牌名称" size="small" clearable v-model="params.brand"> </el-input>
        <span class="header-label" v-if="params.brand != 'IAIYOXI'">排序方式</span>
        <el-select placeholder="请选择" size="small" v-model="params.orderType" v-if="params.brand != 'IAIYOXI'">
          <el-option v-for="item in orderTypeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <span class="header-label">Asin类型</span>
        <el-select placeholder="请选择" size="small" v-model="params.asinType">
          <el-option v-for="item in asinTypes" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </div>
      <div class="header-line" v-if="params.brand != 'IAIYOXI'">
        <span class="header-label">类型</span>
        <el-select placeholder="请选择" size="small" v-model="params.star">
          <el-option v-for="item in starTypeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <span class="header-label">排名</span>
        <el-input size="small" clearable class="small-margin-right" v-model="params.beginRank" style="width: 80px"></el-input>
        --
        <el-input size="small" clearable v-model="params.endRank" style="width: 80px"></el-input>
        <span class="header-label">评论数量</span>
        <el-input size="small" clearable class="small-margin-right" v-model="params.beginCommentCount" style="width: 80px"> </el-input>
        --
        <el-input size="small" clearable v-model="params.endCommentCount" style="width: 80px"> </el-input>
        <span class="header-label">价格区间</span>
        <el-input size="small" clearable class="small-margin-right" v-model="params.beginUnitPrice" style="width: 80px"> </el-input>
        --
        <el-input size="small" clearable v-model="params.endUnitPrice" style="width: 80px"> </el-input>
      </div>
      <div class="header-line">
        <el-button type="primary" size="small" @click="resetParams">重置</el-button>
        <el-button type="primary" size="small" @click="queryAmazonList">查询</el-button>
      </div>
    </div>
    <el-row ref="topBox" class="top-box">
      <el-col :span="4">
        <span class="total-span" size="small">商品总数: {{ subInfo.totalCount }}</span>
      </el-col>
      <el-col :span="4">
        <span class="total-span" size="small">前1000商品总数: {{ subInfo.limitRankTotalCount }}</span>
      </el-col>
      <el-col :span="4">
        <span class="total-span" size="small">{{ subInfo.shopName }}商品总数: </span>
        <el-button type="text" v-on:click="onSelfTotalCountClick('IAIYOXI')" style="padding: 0px">{{ subInfo.selfTotalCount }} </el-button>
      </el-col>
      <el-col :span="4">
        <span class="total-span" size="small">{{ subInfo.shopName }}前1000商品总数: </span>
        <el-button type="text" v-on:click="onSelfLimitRankTotalCountClick('IAIYOXI')" style="padding: 0px">
          {{ subInfo.selfLimitRankTotalCount }}
        </el-button>
      </el-col>
      <el-col :span="4">
        <span class="total-span" size="small">前500名商品覆盖率: {{ subInfo.topFiveHundredCoverage }}%</span>
      </el-col>
    </el-row>
    <el-table :data="tableData" border size="mini" :height="screenHeight" style="width: 100%" ref="table" cell-class-name="out-table-cell" row-class-name="out-table-row" header-cell-class-name="out-table-header-cell" header-row-class-name="out-table-header-row" :expand-row-keys="expands" :row-key="getRowKeys">
      <el-table-column type="expand" width="1">
        <template v-slot="scopeOut">
          <el-table :data="scopeOut.row.competitionCommodityStatisticsList" border size="mini" :show-header="false" cell-class-name="out-table-cell" row-class-name="out-table-row" header-cell-class-name="out-table-header-cell" header-row-class-name="out-table-header-row" style="margin-left: 90px">
            <el-table-column width="50px" align="center">
              <template v-slot="scope">
                <el-button type="text" v-on:click="deleteAsin(scope.row, scopeOut.row)">删除</el-button>
              </template>
            </el-table-column>

            <el-table-column width="50px;" label="图片" align="center">
              <template v-slot="scope">
                <el-image style="height: 40px; width: 40px" :src="scope.row.imageURL1" fit="fill" @error="imageError"> </el-image>
              </template>
            </el-table-column>

            <el-table-column label="备注" width="60px">
              <template v-slot="scope">
                <el-input
                  size="small"
                  v-model="scope.row.remark"
                  @change="
                    val => {
                      onTableInputChange(val, scope.row, 'remark');
                    }
                  "
                  @focus="onFocus"
                  >>
                </el-input>
              </template>
            </el-table-column>

            <el-table-column prop="rankAverageDif" label="增速" width="40px" align="center">
              <template v-slot="scope">
                <span>{{ scope.row.commentAverageDif }}</span>
                <br />
                <span>{{ scope.row.rankAverageDif }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center">
              <template v-slot="scope">
                <el-table class="cell-table" :data="scope.row.commodityInfo" border size="mini" :show-header="false">
                  <el-table-column type="expand" width="36px">
                    <template v-slot="scope">
                      <el-table :data="scope.row.list" border size="mini" :show-header="false" style="margin-left: 35px">
                        <el-table-column width="80px" prop="rankType" align="center">
                          <template v-slot="scope">
                            {{ scope.row.rankType }}
                          </template>
                        </el-table-column>
                        <el-table-column width="100px" prop="title" label="标题/asin/卖家/卖家商品数" align="center">
                          <template v-slot="scope">
                            <!--                            <el-link target="_blank" :underline="false" :href="scope.row.url">-->
                            <!--                              <span class="blue">{{ scope.row.title }}</span>-->
                            <!--                            </el-link>-->
                            <el-link target="_blank" :underline="false" :href="scope.row.url" v-if="scope.row.rankType == 'asin'">
                              <span class="blue">{{ scope.row.title }}</span>
                            </el-link>
                            <span class="blue" v-if="scope.row.rankType == '卖家'" @click="onShopNameClick(scope.row.title)">{{ scope.row.title }}</span>
                            <span v-if="scope.row.rankType == '品牌' || scope.row.rankType == '卖家商品数'">{{ scope.row.title }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="type" label="asin" width="50px" align="center"></el-table-column>
                        <el-table-column label="" prop="commodityInfo1" width="50px" align="center"> </el-table-column>
                        <el-table-column label="" prop="commodityInfo2" width="50px" align="center"> </el-table-column>
                        <el-table-column label="" prop="commodityInfo3" width="50px" align="center"> </el-table-column>
                        <el-table-column label="" prop="commodityInfo4" width="50px" align="center"> </el-table-column>
                        <el-table-column label="" prop="commodityInfo5" width="50px" align="center"> </el-table-column>
                        <el-table-column label="" prop="commodityInfo6" width="50px" align="center"> </el-table-column>
                        <el-table-column label="" prop="commodityInfo7" width="50px" align="center"> </el-table-column>
                        <el-table-column label="" prop="commodityInfo8" width="50px" align="center"> </el-table-column>
                        <el-table-column label="" prop="commodityInfo9" width="50px" align="center"> </el-table-column>
                        <el-table-column label="" prop="commodityInfo10" width="50px" align="center"> </el-table-column>
                        <el-table-column label="" prop="commodityInfo11" width="50px" align="center"> </el-table-column>
                        <el-table-column label="" prop="commodityInfo12" width="50px" align="center"> </el-table-column>
                        <el-table-column label="" prop="commodityInfo13" width="50px" align="center"> </el-table-column>
                        <el-table-column label="" prop="commodityInfo14" width="50px" align="center"> </el-table-column>
                      </el-table>
                    </template>
                  </el-table-column>
                  <el-table-column width="80px" prop="rankType" align="center">
                    <template v-slot="scope">
                      {{ scope.row.brand }}
                    </template>
                  </el-table-column>
                  <el-table-column width="100px" prop="title" label="标题/asin/卖家/卖家商品数" align="center">
                    <template v-slot="scope">
                      <el-link target="_blank" :underline="false" :href="scope.row.url">
                        <span class="blue">{{ scope.row.asin }}</span>
                      </el-link>
                      <span class="blue" v-if="scope.row.rankType == '卖家'" @click="onShopNameClick(scope.row.title)">{{ scope.row.title }}</span>
                      <span v-if="scope.row.rankType == '品牌' || scope.row.rankType == '卖家商品数'">{{ scope.row.title }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="type" label="" width="50px" align="center"></el-table-column>
                  <el-table-column label="" prop="commodityInfo1" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo2" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo3" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo4" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo5" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo6" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo7" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo8" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo9" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo10" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo11" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo12" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo13" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo14" width="50px" align="center"> </el-table-column>
                </el-table>
              </template>
            </el-table-column>
          </el-table>
          <el-tabs v-model="currentComponent" @tab-click="handleClick" style="margin-left: 90px" v-if="params.asin != ''">
            <el-tab-pane label="关联商品" name="compareProduct"></el-tab-pane>
            <el-tab-pane label="子商品关键词排名" name="keywordsRank"></el-tab-pane>
            <el-tab-pane label="父商品关键词排名" name="parentKeywordsRank"></el-tab-pane>
          </el-tabs>
          <div style="margin-left: 90px" v-if="params.asin != '' && tableData.length == 1">
            <keep-alive>
              <components :is="currentComponent" :productSimilarAsinDataDTOList="scopeOut.row.productSimilarAsinDataDTOList" :productSearchKeywordDataDTOList="scopeOut.row.productSearchKeywordDataDTOList" :competitionProductDataDTO="scopeOut.row.competitionProductDataDTO" :queryParams="params" :version="scopeOut.row.version"> </components>
            </keep-alive>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="90px" align="center">
        <template v-slot="scope">
          <input type="checkbox" :id="markCheckBox(scope.$index)" @change="onMarkChange(scope.row)" v-model="scope.row.star" class="mark-check-box" />
          <label class="mark-label" :for="markCheckBox(scope.$index)"></label>
          <div class="product-info-opreate-box" style="width: 60px; display: inline-block; vertical-align: middle">
            <div class="blue" @click="() => addAsin(scope.row)">添加asin</div>
            <div class="blue" @click="changeExpandCommodity(scope.row)" v-if="scope.row.competitionCommodityStatisticsList.length > 0" style="background-color: #faebd7; border-radius: 4px">展开竞品</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="50px" label="序号" align="center">
        <template slot-scope="scope">
          <span>{{ params.beginIndex + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column width="50px;" label="图片" align="center">
        <template v-slot="scope">
          <el-image style="height: 40px; width: 40px" :src="scope.row.imageURL1" fit="fill" @error="imageError"> </el-image>
        </template>
      </el-table-column>
      <el-table-column label="备注" width="60px">
        <template v-slot="scope">
          <el-input
            size="small"
            v-model="scope.row.remark"
            @change="
              val => {
                onTableInputChange(val, scope.row, 'remark');
              }
            "
            @focus="onFocus"
          >
          </el-input>
        </template>
      </el-table-column>
      <el-table-column prop="rankAverageDif" label="增速" width="40px" align="center">
        <template v-slot="scope">
          <span>{{ scope.row.rankAverageDif }}</span>
          <br />
          <span>{{ scope.row.commentAverageDif }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center">
        <template #header>
          <el-table size="mini" style="height: 47px" cell-class-name="out-table-cell" row-class-name="out-table-row">
            <el-table-column width="116px" align="center"> </el-table-column>
            <el-table-column width="100px" label="标题/asin/卖家/卖家商品数" align="center"> </el-table-column>
            <el-table-column width="50px" align="center"> </el-table-column>
            <el-table-column :label="subInfo.date1" width="50px" align="center"> </el-table-column>
            <el-table-column :label="subInfo.date2" width="50px" align="center"> </el-table-column>
            <el-table-column :label="subInfo.date3" width="50px" align="center"> </el-table-column>
            <el-table-column :label="subInfo.date4" width="50px" align="center"> </el-table-column>
            <el-table-column :label="subInfo.date5" width="50px" align="center"> </el-table-column>
            <el-table-column :label="subInfo.date6" width="50px" align="center"> </el-table-column>
            <el-table-column :label="subInfo.date7" width="50px" align="center"> </el-table-column>
            <el-table-column :label="subInfo.date8" width="50px" align="center"> </el-table-column>
            <el-table-column :label="subInfo.date9" width="50px" align="center"> </el-table-column>
            <el-table-column :label="subInfo.date10" width="50px" align="center"> </el-table-column>
            <el-table-column :label="subInfo.date11" width="50px" align="center"> </el-table-column>
            <el-table-column :label="subInfo.date12" width="50px" align="center"> </el-table-column>
            <el-table-column :label="subInfo.date13" width="50px" align="center"> </el-table-column>
            <el-table-column :label="subInfo.date14" width="50px" align="center"> </el-table-column>
          </el-table>
        </template>
        <template v-slot="scope">
          <el-table class="cell-table" :data="scope.row.commodityInfo" size="mini" :show-header="false" cell-class-name="out-table-cell" row-class-name="out-table-row">
            <el-table-column type="expand" width="36px">
              <template v-slot="scope">
                <el-table :data="scope.row.list" border size="mini" :show-header="false" style="margin-left: 35px">
                  <el-table-column width="80px" prop="rankType" align="center">
                    <template v-slot="scope">
                      {{ scope.row.rankType }}
                    </template>
                  </el-table-column>
                  <el-table-column width="100px" prop="title" label="标题/asin/卖家/卖家商品数" align="center">
                    <template v-slot="scope">
                      <el-link target="_blank" :underline="false" :href="scope.row.url" v-if="scope.row.rankType == 'asin'">
                        <span class="blue">{{ scope.row.title }}</span>
                      </el-link>
                      <span class="blue" v-if="scope.row.rankType == '卖家'" @click="onShopNameClick(scope.row.title)">{{ scope.row.title }}</span>
                      <span v-if="scope.row.rankType == '品牌' || scope.row.rankType == '卖家商品数'">{{ scope.row.title }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="type" label="" width="50px" align="center"></el-table-column>
                  <el-table-column label="" prop="commodityInfo1" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo2" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo3" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo4" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo5" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo6" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo7" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo8" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo9" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo10" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo11" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo12" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo13" width="50px" align="center"> </el-table-column>
                  <el-table-column label="" prop="commodityInfo14" width="50px" align="center"> </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column width="80px" prop="rankType" align="center">
              <template v-slot="scope">
                {{ scope.row.rankType }}
              </template>
            </el-table-column>
            <el-table-column width="100px" prop="title" label="标题/asin/卖家/卖家商品数11" align="center">
              <template v-slot="scope">
                <el-link target="_blank" :underline="false" :href="scope.row.url">
                  <span class="blue">{{ scope.row.title }}</span>
                </el-link>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="" width="50px" align="center"></el-table-column>
            <el-table-column label="" prop="commodityInfo1" width="50px" align="center"> </el-table-column>
            <el-table-column label="" prop="commodityInfo2" width="50px" align="center"> </el-table-column>
            <el-table-column label="" prop="commodityInfo3" width="50px" align="center"> </el-table-column>
            <el-table-column label="" prop="commodityInfo4" width="50px" align="center"> </el-table-column>
            <el-table-column label="" prop="commodityInfo5" width="50px" align="center"> </el-table-column>
            <el-table-column label="" prop="commodityInfo6" width="50px" align="center"> </el-table-column>
            <el-table-column label="" prop="commodityInfo7" width="50px" align="center"> </el-table-column>
            <el-table-column label="" prop="commodityInfo8" width="50px" align="center"> </el-table-column>
            <el-table-column label="" prop="commodityInfo9" width="50px" align="center"> </el-table-column>
            <el-table-column label="" prop="commodityInfo10" width="50px" align="center"> </el-table-column>
            <el-table-column label="" prop="commodityInfo11" width="50px" align="center"> </el-table-column>
            <el-table-column label="" prop="commodityInfo12" width="50px" align="center"> </el-table-column>
            <el-table-column label="" prop="commodityInfo13" width="50px" align="center"> </el-table-column>
            <el-table-column label="" prop="commodityInfo14" width="50px" align="center"> </el-table-column>
          </el-table>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :page-count="totalPage" @prev-click="prevBtnClick" @next-click="nextBtnClick">
    </el-pagination> -->
    <el-pagination ref="pageNav" layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :pager-count="21" :page-count="totalPage" :page-size="params.pageSize" :total="subInfo.totalCount" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick"> </el-pagination>
    <el-dialog title="添加asin" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="asin" :label-width="formLabelWidth">
          <el-input v-model="form.competitionAsin" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAsin">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { amazonModules } from "@r";
import CompareProduct from "@v/commodityMgmt/CompareProduct.vue";
import KeywordsRank from "@v/commodityMgmt/KeywordsRank.vue";
import parentKeywordsRank from "@v/commodityMgmt/ParentKeywordsRank.vue";

export default {
  props: {
    country: {
      type: String,
    },
  },
  data() {
    return {
      screenHeight: document.body.clientHeight - 54 - 52 - 55 - 68 - 158,
      params: {
        asin: "",
        shopName: "",
        brand: "",
        orderType: "",
        star: "",
        beginRank: "",
        endRank: "",
        beginCommentCount: "",
        endCommentCount: "",
        beginUnitPrice: "",
        endUnitPrice: "",
        beginIndex: 0,
        pageSize: 50,
        asinType: "1",
      },
      starTypeOptions: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "打星",
          value: "1",
        },
        {
          label: "不打星",
          value: "2",
        },
      ],
      orderTypeOptions: [
        {
          label: "排名",
          value: "1",
        },
        {
          label: "排名增速",
          value: "2",
        },
        {
          label: "评论增速",
          value: "3",
        },
      ],
      asinTypes: [
        {
          label: "父商品",
          value: "1",
        },
        {
          label: "子商品",
          value: "2",
        },
      ],
      subInfo: {
        totalCount: 0,
        limitRankTotalCount: 0,
        selfTotalCount: 0,
        selfLimitRankTotalCount: 0,
        topFiveHundredCoverage: 0,
        date1: "",
        date2: "",
        date3: "",
        date4: "",
        date5: "",
        date6: "",
        date7: "",
        date8: "",
        date9: "",
        date10: "",
        date11: "",
        date12: "",
        date13: "",
        date14: "",
      },
      focusValue: "",
      oldTableData: [],
      rankTypeObject: ["asin", "品牌", "卖家", "卖家商品数", ""],
      typeObject: ["排名", "评论数", "评分", "售价", "销量"],
      titleObject: ["asin", "brand", "shopName", "shopTotalCount", ""],
      form: {
        competitionAsin: "",
        id: 0,
        remark: "",
      },
      dialogFormVisible: false,
      formLabelWidth: "100px",
      expands: [],
      currentComponent: "compareProduct",
      totalPage: 1,
      currentPage: 1,
    };
  },
  components: {
    compareProduct: CompareProduct,
    keywordsRank: KeywordsRank,
    parentKeywordsRank: parentKeywordsRank,
  },
  mounted() {
    // this.screenHeight = screen.availHeight - 54 - 52 - 54 - 55 - this.$refs.header.clientHeight - this.$refs.pageNav.clientHeight - this.$refs.topBox.clientHeight
  },
  methods: {
    tableSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0 && columnIndex == 0) {
        return [100, 1];
      } else if (rowIndex > 0 && columnIndex == 0) {
        return [0, 0];
      }
    },
    onShopNameClick(shopName) {
      this.params.shopName = shopName;
      this.queryAmazonList();
    },
    onMarkChange(row) {
      amazonModules
        .changeStar({
          id: row.id,
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "操作失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "操作成功",
          });
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "操作失败",
          });
        });
    },
    onSelfTotalCountClick(brand) {
      this.resetQueryParams();
      this.params.brand = brand;
      this.queryAmazonList();
    },
    onSelfLimitRankTotalCountClick(brand) {
      this.resetQueryParams();
      this.params.brand = brand;
      this.params.beginRank = 0;
      this.params.endRank = 1000;
      this.queryAmazonList();
    },
    getRowKeys(row) {
      // 行数据的Key
      return row.asin;
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.queryAmazonList();
    },
    // prevBtnClick() {
    //   if (this.params.beginIndex <= 0) {
    //     this.$message({
    //       type: 'info',
    //       message: '已经到头了!'
    //     })
    //     return;
    //   }
    //   this.params.beginIndex = this.params.beginIndex - this.params.pageSize + 1;
    //   this.queryAmazonList();
    // },
    // nextBtnClick() {
    //   if (this.tableData.length < this.params.pageSize - 1) {
    //     this.$message({
    //       type: 'info',
    //       message: '没有更多了!'
    //     })
    //     return;
    //   }
    //   this.params.beginIndex = this.params.beginIndex + this.params.pageSize - 1;
    //   this.queryAmazonList();
    // },
    resetParams() {
      this.resetQueryParams();
      this.queryAmazonList();
    },
    resetQueryParams() {
      this.params = {
        asin: "",
        shopName: "",
        brand: "",
        orderType: "",
        star: "",
        beginRank: "",
        endRank: "",
        beginCommentCount: "",
        endCommentCount: "",
        beginUnitPrice: "",
        endUnitPrice: "",
        beginIndex: 0,
        pageSize: 51,
      };
    },
    queryAmazonList() {
      this.expands = [];
      amazonModules
        .list(
          Object.assign({}, this.params, {
            "country": this.country,
          })
        )
        .then(res => {
          if (res.result !== 1) {
            this.oldTableData = [];
            this.$message({
              type: "error",
              message: res.message ? res.message : "列表请求失败",
            });
            return;
          }
          this.subInfo = res.mdata;
          this.oldTableData = res.ldata;
          this.params.asin && this.expands.push(this.params.asin);
          this.totalPage = Math.ceil(this.subInfo.totalCount / this.params.pageSize);
        });
    },
    getRowKey(row) {
      return row.asin;
    },
    insertTableCellClick(row, column, cell, event) {
      if (cell.getAttribute("class").indexOf("product-shop-name") > 0) {
        this.params.shopName = row.title;
        this.queryAmazonList();
      }
    },
    remarkInputFocus(e, row) {
      let value = e.target.value;
      this.focusProductRemark = value;
      this.form.id = row.id;
    },
    onFocus(e) {
      this.focusValue = e.currentTarget.value;
    },
    onTableInputChange(e, row, propName) {
      this.$confirm("是否确认修改?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          amazonModules
            .editRemark({
              id: row.id,
              remark: row.remark,
            })
            .then(res => {
              if (res.result !== 1) {
                e.target.value = this.focusProductRemark;
                this.$message({
                  type: "error",
                  message: res.message ? res.message : "添加备注失败",
                });
                return;
              }
              this.$message({
                type: "success",
                message: "添加成功",
              });
            })
            .catch(err => {
              this.$message({
                type: "error",
                message: err.message ? err.message : "添加备注失败",
              });
            });
        })
        .catch(() => {
          row[propName] = this.focusValue;
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    changeExpandCommodity(row) {
      this.$refs.table.toggleRowExpansion(row);
    },
    imageError(e) {
      console.log(e);
    },
    addAsin(row) {
      this.$prompt("请输入Asin", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          // eslint-disable-next-line eqeqeq
          if (value == "") {
            this.$message({
              type: "warning",
              message: "请输入asin",
            });
            return;
          }

          amazonModules
            .editCompetitionAsin({
              // id: row.id,
              asin: row.asin,
              competitionAsin: value,
            })
            .then(res => {
              if (res.result !== 1) {
                this.$message({
                  type: "error",
                  message: res.message ? res.message : "添加asin失败",
                });
                return;
              }
              this.$message({
                type: "success",
                message: "添加成功",
              });
              this.queryAmazonList();
            })
            .catch(err => {
              this.$message({
                type: "error",
                message: err.message ? err.message : "添加asin失败",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    deleteAsin(row, scopeOutRow) {
      this.$confirm("是否确认删除竞品asin?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          amazonModules
            .deleteCompetitionAsin({
              competitionAsin: row.asin,
              id: scopeOutRow.id,
            })
            .then(res => {
              if (res.result !== 1) {
                this.$message({
                  type: "error",
                  message: err.message ? err.message : "删除失败",
                });
                return;
              }
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.queryAmazonList();
            })
            .catch(err => {
              this.$message({
                type: "error",
                message: err.message ? err.message : "删除失败",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消删除",
          });
        });
    },
    createCommodityList(item) {
      let commodityList = [];
      let len = 0;
      for (let i = 1; i <= 14; i++) {
        let colList = item["commodityInfo" + i].split("/");
        delete item["commodityInfo" + i];
        colList.length > len && (len = colList.length);
        // 获取不同单元格
        for (let j = 0; j < colList.length; j++) {
          !commodityList[j] && (commodityList[j] = []);
          commodityList[j].push(colList[j]);
        }
      }
      return {
        commodityList,
        len,
      };
    },
    markCheckBox(index) {
      return "markCheckBox" + index;
    },
    handleClick(e) {
      this.currentComponent = e.$options.propsData.name;
    },
  },
  created() {
    this.params.shopName = this.$route.query.shopName;
    this.params.brand = this.$route.query.brandName;
    this.params.asin = this.$route.query.asin;
    if (this.$route.query.rank > 0) {
      this.params.orderType = 1;
      this.params.beginRank = 0;
      this.params.endRank = this.$route.query.rank;
    }
    this.queryAmazonList();
  },
  computed: {
    tableData: function () {
      let newtable = [];
      this.oldTableData.forEach((item, index) => {
        let childCommodityList = [];
        if (item.competitionCommodityStatisticsList.length > 0) {
          item.competitionCommodityStatisticsList.forEach(value => {
            let commodityList = [];
            for (var j = 0; j < 5; j++) {
              var commodityInfo = {
                rankType: this.rankTypeObject[j] == "asin" ? value["brandName"] : this.rankTypeObject[j],
                type: this.typeObject[j],
                title: this.titleObject[j] ? value[this.titleObject[j]] : "",
                ...value,
              };
              commodityInfo.commodityInfo1 = value.commodityInfo1.split("/")[j];
              commodityInfo.commodityInfo2 = value.commodityInfo2.split("/")[j];
              commodityInfo.commodityInfo3 = value.commodityInfo3.split("/")[j];
              commodityInfo.commodityInfo4 = value.commodityInfo4.split("/")[j];
              commodityInfo.commodityInfo5 = value.commodityInfo5.split("/")[j];
              commodityInfo.commodityInfo6 = value.commodityInfo6.split("/")[j];
              commodityInfo.commodityInfo7 = value.commodityInfo7.split("/")[j];
              commodityInfo.commodityInfo8 = value.commodityInfo8.split("/")[j];
              commodityInfo.commodityInfo9 = value.commodityInfo9.split("/")[j];
              commodityInfo.commodityInfo10 = value.commodityInfo10.split("/")[j];
              commodityInfo.commodityInfo11 = value.commodityInfo11.split("/")[j];
              commodityInfo.commodityInfo12 = value.commodityInfo12.split("/")[j];
              commodityInfo.commodityInfo13 = value.commodityInfo13.split("/")[j];
              commodityInfo.commodityInfo14 = value.commodityInfo14.split("/")[j];

              commodityList.push(commodityInfo);
            }
            childCommodityList.push({
              commodityInfo: [
                {
                  list: commodityList.slice(1, 5),
                  ...commodityList[0],
                },
              ],
              competitionCommodityStatisticsList: commodityList[0].competitionCommodityStatisticsList,
              ...commodityList[0],
            });
          });
        }

        let commodityList = [];
        for (var i = 0; i < 5; i++) {
          var commodityInfo = {
            rankType: this.rankTypeObject[i],
            rankType: this.rankTypeObject[i] == "asin" ? item["brand"] : this.rankTypeObject[i],
            type: this.typeObject[i],
            title: this.titleObject[i] ? item[this.titleObject[i]] : "",
            ...item,
          };
          commodityInfo.commodityInfo1 = item.commodityInfo1.split("/")[i];
          commodityInfo.commodityInfo2 = item.commodityInfo2.split("/")[i];
          commodityInfo.commodityInfo3 = item.commodityInfo3.split("/")[i];
          commodityInfo.commodityInfo4 = item.commodityInfo4.split("/")[i];
          commodityInfo.commodityInfo5 = item.commodityInfo5.split("/")[i];
          commodityInfo.commodityInfo6 = item.commodityInfo6.split("/")[i];
          commodityInfo.commodityInfo7 = item.commodityInfo7.split("/")[i];
          commodityInfo.commodityInfo8 = item.commodityInfo8.split("/")[i];
          commodityInfo.commodityInfo9 = item.commodityInfo9.split("/")[i];
          commodityInfo.commodityInfo10 = item.commodityInfo10.split("/")[i];
          commodityInfo.commodityInfo11 = item.commodityInfo11.split("/")[i];
          commodityInfo.commodityInfo12 = item.commodityInfo12.split("/")[i];
          commodityInfo.commodityInfo13 = item.commodityInfo13.split("/")[i];
          commodityInfo.commodityInfo14 = item.commodityInfo14.split("/")[i];
          commodityInfo.competitionCommodityStatisticsList = childCommodityList;
          commodityList.push(commodityInfo);
        }

        newtable.push({
          commodityInfo: [
            {
              list: commodityList.slice(1, 5),
              ...commodityList[0],
            },
          ],
          competitionCommodityStatisticsList: commodityList[0].competitionCommodityStatisticsList,
          ...commodityList[0],
        });
      });

      // this.currentPage = this.params.beginIndex / (this.params.pageSize - 1) + 1;
      // if (newtable.length >= this.params.pageSize - 1) {
      //   newtable.pop();
      // this.totalPage = this.currentPage + 1;
      // }

      return newtable;
    },
  },
};
</script>

<style lang="scss">
.blue {
  color: #5893ff;
  cursor: pointer;
}

.header-box {
  text-align: left;
  line-height: 30px;
  padding-left: 10px;
  padding-top: 10px;
  padding-bottom: 10px;

  .el-input,
  .el-select {
    width: 80px;
    margin-right: 15px;
    margin-left: 5px;
  }

  .el-button {
    width: 80px;
  }

  .header-line {
    margin-bottom: 20px;
  }

  .header-line:last-of-type {
    margin-bottom: 0px;
  }

  .small-margin-right {
    margin-right: 5px;
  }

  .header-label {
    font-size: 16px;
  }
}

.top-box {
  line-height: 30px;
  padding-left: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-left: 1px solid #ededed;
  border-right: 1px solid #ededed;
  border-top: 1px solid #ededed;
}

.out-table-cell {
  padding: 0px !important;

  .cell {
    padding: 0px !important;
  }
}

.out-table-row {
  padding: 0px !important;
}

.el-table {
  .el-table__expanded-cell {
    padding: 0px;
  }
}

.out-table-header-cell {
  padding: 0px !important;

  .cell {
    padding: 0px !important;
  }
}

.total-span {
  font-size: 14px;
  color: #909399;
}

// .el-table .cell,
// .el-table--border td:first-child .cell,
// .el-table--border th:first-child .cell {
//   padding: 0px;

//   .el-input {
//     margin-right: 0px;
//     margin-left: 0px;

//     .el-input__inner {
//       padding-left: 2px;
//       padding-right: 2px;
//     }
//   }
// }
// .el-table td, .el-table th{
//   padding: 0px;
//   .cell{
//     padding: 0px;
//   }
// }

.mark-label {
  vertical-align: middle;
  width: 20px;
  height: 20px;
  display: inline-block;
}

.mark-check-box {
  display: none;

  + .mark-label {
    background-image: url(../../assets/un-mark-icon.png);
    background-repeat: no-repeat;
    background-size: cover;
  }
}

.mark-check-box:checked {
  + .mark-label {
    background-image: url(../../assets/mark-icon.png);
    background-repeat: no-repeat;
    background-size: cover;
  }
}

.cell-table {
  .el-table__body {
    height: 48px;
  }
}

#commodityMgmt {
  .el-table .cell,
  .el-table--border td:first-child .cell,
  .el-table--border th:first-child .cell {
    padding: 0px 3px;

    .el-input {
      margin-right: 0px;
      margin-left: 0px;

      .el-input__inner {
        padding-left: 2px;
        padding-right: 2px;
      }
    }
  }
}
</style>
